import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './css/hacks.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Amplify } from "aws-amplify";
import './localisation/i18n';
import { Provider } from "react-redux";
import store from './stores';
import { SnackbarProvider } from './yoello-lib/modules/components/snackbar/SnackbarContext';
import { AuthProvider } from "./yoello-lib/modules/auth/AuthenticationContext";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import TagManager from 'react-gtm-module';
import './yoello-lib/modules/host/HostClient';

//Amplify Cognito configuration
Amplify.configure({
  Auth: {
    region: "eu-west-1",
    userPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USERPOOL_WEBCLIENTID,
    mandatorySignIn: "true",
    authenticationFlowType: "USER_PASSWORD_AUTH",
    scope: ["openid, email, profile"],
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: ["openid", "email", "aws.cognito.signin.user.admin"],
      redirectSignIn: `${window.location.origin}/login/oauthredirect`,
      redirectSignOut: window.location.origin,

      responseType: "code",
    },
  },
});

const tagManagerArgs = {
  gtmId: 'GTM-MR4RV3R'
}

TagManager.initialize(tagManagerArgs)

// const env = getDynamicEnviroment();
ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <SnackbarProvider >
        <Provider store={store}>
      <AuthProvider>
          <App />
      </AuthProvider>
        </Provider>
    </SnackbarProvider>
  </MuiPickersUtilsProvider>,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
